module.exports = __webpack_public_path__ + "img/water-disabled.ca80a5d9.png";